import { Skeleton, Stack } from "@mui/material";

export const SocialApplyCardSkeleton = () => {
  return (
    <Stack sx={{ height: 900, overflowX: "hidden", overflowY: "auto", flex: "auto", pl: 8, pr: 8, gap: 2 }}>
      <Skeleton
        variant="rectangular"
        sx={(theme) => ({ width: `calc(100% - ${theme.spacing(2)})`, height: 50, borderRadius: "5px" })}
      />
    </Stack>
  );
};
